import Svg, { SvgProps, Path } from 'react-native-svg';

const ReleaseIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M8 5.5A1.5 1.5 0 0 0 6.5 7v15a1.5 1.5 0 0 0 3 0V7A1.5 1.5 0 0 0 8 5.5zm5.5 0a1 1 0 0 0-1 1 1 1 0 0 0 0 .004v15.992a1 1 0 0 0 0 .004 1 1 0 0 0 1 1 1 1 0 0 0 .592-.195h.002a1 1 0 0 0 .027-.022l10.92-7.941a1 1 0 0 0 .459-.842 1 1 0 0 0-.443-.83L14.094 5.695A1 1 0 0 0 13.5 5.5z" />
  </Svg>
);

export default ReleaseIcon;
